// modules/facturacion/pages/FacturacionPage.jsx
import React, { useState } from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import SearchIcon from "@mui/icons-material/Search";
import DescriptionIcon from "@mui/icons-material/Description";
import DashboardLayout from "../../../layouts/DashboardLayout";
import FacturacionMasivaTab from "../components/FacturacionMasivaTab";
import BusquedaClientesTab from "../components/BusquedaClientesTab";
import PrefacturasTab from "../components/PrefacturasTab";

const MASIVA_INICIAL = {
  lista: [],
  sucursal: "",
  seleccionados: [],
  buscar: "",
  page: 1,
  pageSize: 30,
  total: 0,
};

function TabPanel({ active, children }) {
  return (
    <Box
      role="tabpanel"
      hidden={!active}
      sx={{ display: active ? "block" : "none" }}
    >
      {children}
    </Box>
  );
}

const FacturacionPage = () => {
  const [tab, setTab] = useState(0);
  const [masivaState, setMasivaState] = useState(MASIVA_INICIAL);

  return (
    <DashboardLayout>
      <Box
        sx={{
          width: "100%",
          minHeight: "calc(100vh - 64px)",
          bgcolor: "background.default",
          p: { xs: 1, md: 1.5 },
        }}
      >

        <Paper variant="outlined" sx={{ mb: 1, overflow: "hidden" }}>
          <Tabs
            value={tab}
            onChange={(_, value) => setTab(value)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 34,
              "& .MuiTab-root": {
                minHeight: 34,
                py: 0.5,
                px: 1.25,
                fontSize: 12,
                textTransform: "none",
              },
            }}
          >
            <Tab icon={<ViewListIcon />} iconPosition="start" label="Facturacion Masiva" />
            <Tab icon={<SearchIcon />} iconPosition="start" label="Busqueda de Clientes" />
            <Tab icon={<DescriptionIcon />} iconPosition="start" label="Prefacturas" />
          </Tabs>
        </Paper>

        <TabPanel active={tab === 0}>
          <FacturacionMasivaTab
            state={masivaState}
            setState={setMasivaState}
          />
        </TabPanel>
        <TabPanel active={tab === 1}>
          <BusquedaClientesTab />
        </TabPanel>
        <TabPanel active={tab === 2}>
          <PrefacturasTab />
        </TabPanel>
      </Box>
    </DashboardLayout>
  );
};

export default FacturacionPage;
